const devServices = [
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKey: null,
    },
    {
        id: "fpm",
        url: "https://fpm-dev.c12r.io",
        permissionKey: "fpm.access",
    },
    {
        id: "fpc",
        url: "https://corporate-frontend.dev.c12r.io",
        permissionKey: "fpc.access",
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKey: "network-supplier.access",
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKey: "network-purchaser.access",
    },
];
const stagingServices = [
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKey: null,
    },
    {
        id: "fpm",
        url: "https://fpm-staging.c12r.io",
        permissionKey: "fpm.access",
    },
    {
        id: "fpc",
        url: "https://corporate-frontend.stg.c12r.io",
        permissionKey: "fpc.access",
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKey: "network-supplier.access",
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKey: "network-purchaser.access",
    },
    {
        id: "cfc",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.access",
    },
    {
        id: "cfc.ccf-basic",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-basic.access",
    },
    {
        id: "cfc.ccf-enterprise",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-enterprise.access",
    },
    {
        id: "cfc.ccf-assessment",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-assessment.access",
    },
    {
        id: "cfc.ccf-employee-commuting-survey",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-employee-commuting-survey.access",
    },
    {
        id: "transparency-dashboard-frontend",
        url: "http://localhost:3000",
        permissionKey: "transparency-dashboard-frontend.access",
    },
    {
        id: "reduction-homepage-frontend",
        url: "https://reduction-homepage-frontend-staging.smart-staging.c12r.io",
        permissionKey: null,
    },
    {
        id: "analytics.basic",
        url: "http://localhost:5178",
        permissionKey: "analytics.basic.access",
    },
];
const prodServices = [
    {
        id: "fpm",
        url: "https://fpm.climatepartner.com",
        permissionKey: "fpm.access",
    },
    {
        id: "fpc",
        url: "https://calc.climatepartner.com",
        permissionKey: "fpc.access",
    },
    {
        id: "homescreen",
        url: "https://app.climatepartner.com",
        permissionKey: null, // accessible for everyone
    },
    {
        id: "network-supplier",
        url: "https://network.climatepartner.com",
        permissionKey: "network-supplier.access",
    },
    {
        id: "network-purchaser",
        url: "https://network.climatepartner.com",
        permissionKey: "network-purchaser.access",
    },
    {
        id: "cfc",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.access",
    },
    {
        id: "cfc.ccf-basic",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-basic.access",
    },
    {
        id: "cfc.ccf-enterprise",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-enterprise.access",
    },
    {
        id: "cfc.ccf-assessment",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-assessment.access",
    },
    {
        id: "cfc.ccf-employee-commuting-survey",
        url: "https://calculation.climatepartner.com",
        permissionKey: "cfc.ccf-employee-commuting-survey.access",
    },
    {
        id: "transparency-dashboard-frontend",
        url: "https://transparency.climatepartner.com",
        permissionKey: "transparency-dashboard-frontend.access",
    },
    {
        id: "reduction-homepage-frontend",
        url: "https://reduction.climatepartner.com",
        permissionKey: null,
    },
    {
        id: "analytics.basic",
        url: "https://analytics.climatepartner.com/",
        permissionKey: "analytics.basic.access",
    },
];
const mapEnvironmentToServices = (environment) => {
    switch (environment) {
        case "dev":
            return devServices;
        case "staging":
            return stagingServices;
        case "prod":
            return prodServices;
        default:
            throw new Error("Invalid environment");
    }
};
export const getServiceUrls = ({ env, userHasPermission, }) => {
    const serviceUrls = mapEnvironmentToServices(env);
    if (!userHasPermission) {
        return serviceUrls.map(({ id, url }) => ({
            id,
            url,
        }));
    }
    return serviceUrls.map(({ id, url, permissionKey }) => ({
        id,
        url,
        userHasAccess: permissionKey ? userHasPermission(permissionKey) : true,
    }));
};
//# sourceMappingURL=getServiceUrls.js.map